import React from "react";
import styled from "styled-components";
import VideoStream from "./VideoStream";
import { get_vtuber_videos, reset_vtuber_videos } from "../../actions/vtuber";
import { useDispatch, useSelector } from "react-redux";
import Wrapper from "../atoms/Wrapper";

const StyledWrapper = styled(Wrapper)`
  flex-direction: column;
  width: 96%;
  align-items: flex-start;
  box-sizing: border-box;

  @media (max-width: 450px) {
    width: 100%;
  }
`;

const VTuberVideoStream = props => {
  const dispatch = useDispatch();
  const { page, state, items, has_more } = useSelector(
    state => state.vtuber.videos
  );
  // const loadMore = page => {
  //   props.name && dispatch(get_vtuber_videos(props.name)(page));
  // };
  const loadMore = name => page => {
    dispatch(get_vtuber_videos(name)(page));
  };
  React.useEffect(() => {
    return () => dispatch(reset_vtuber_videos());
  }, [dispatch]);
  return (
    <StyledWrapper>
      {props.name && (
        <VideoStream
          items={items}
          loadMore={loadMore(props.name)}
          page={page}
          hasMore={has_more}
          requestState={state}
          ad
          adType="vtuber"
        />
      )}
    </StyledWrapper>
  );
};

export default VTuberVideoStream;
